<section class="!mt-10" aria-labelledby="latest-convocation-heading">
    <h2
        id="latest-convocation-heading"
        class="!mb-4 !flex !flex-wrap !items-center !gap-2 !text-2xl !font-bold !tracking-tight !text-strong"
    >
        <i class="bi bi-megaphone !mb-0" aria-hidden="true"></i>
        Ultima convocazione
    </h2>

    <div
        *ngIf="loading"
        class="latest-convocation-skeleton !overflow-hidden !rounded-3xl !border !border-border !bg-white !shadow-md !ring-1 !ring-black/[0.04]"
        role="status"
        aria-label="Caricamento ultima convocazione"
    >
        <div class="!border-b !border-border !bg-zinc-50/80 !px-6 !py-5 md:!px-8 md:!py-6">
            <div class="!flex !flex-col !gap-4 md:!flex-row md:!items-start md:!justify-between">
                <div class="!min-w-0 !flex-1 !space-y-3">
                    <div class="mister-sk !h-3 !w-24"></div>
                    <div class="mister-sk !h-8 !w-full !max-w-md"></div>
                    <div class="mister-sk !h-8 !w-4/5 !max-w-sm md:!hidden"></div>
                </div>
                <div class="mister-sk !h-8 !w-28 !shrink-0 !rounded-full"></div>
            </div>
        </div>
        <div class="!grid !gap-6 !px-6 !py-6 md:!grid-cols-[minmax(0,14rem)_1fr] md:!gap-10 md:!px-8 md:!py-8">
            <div class="!rounded-2xl !border !border-border !bg-white !p-5 !shadow-sm">
                <div class="!flex !gap-3">
                    <div class="mister-sk !h-11 !w-11 !shrink-0 !rounded-xl"></div>
                    <div class="!flex-1 !space-y-2 !pt-0.5">
                        <div class="mister-sk !h-5 !w-full"></div>
                        <div class="mister-sk !h-4 !w-2/3"></div>
                    </div>
                </div>
            </div>
            <div class="!min-w-0 !space-y-5">
                <div class="!space-y-3">
                    <div class="mister-sk !h-3 !w-16"></div>
                    <div class="mister-sk !h-6 !w-3/4 !max-w-xs"></div>
                    <div class="mister-sk !h-4 !w-full"></div>
                    <div class="mister-sk !h-4 !w-5/6"></div>
                </div>
                <div class="!space-y-3 !border-t !border-border !pt-5">
                    <div class="mister-sk !h-3 !w-20"></div>
                    <div class="mister-sk !h-4 !w-full"></div>
                    <div class="mister-sk !h-4 !w-full"></div>
                    <div class="mister-sk !h-4 !w-4/5"></div>
                </div>
            </div>
        </div>
        <div class="!flex !flex-wrap !gap-3 !border-t !border-border !bg-zinc-50/60 !px-6 !py-4 md:!px-8 md:!py-5">
            <div class="mister-sk !h-10 !w-44 !rounded-lg"></div>
            <div class="mister-sk !h-10 !w-40 !rounded-lg"></div>
        </div>
    </div>

    <p *ngIf="!loading && !convocation" class="!mb-0 !text-sm !text-subtle">
        Non hai ancora convocazioni da mostrare qui.
    </p>

    <article
        *ngIf="!loading && convocation as c"
        class="!overflow-hidden !rounded-3xl !border !border-border !bg-white !shadow-md !ring-1 !ring-black/[0.04]"
    >
        <div class="!flex !items-start !gap-4 !px-6 !py-6 md:!gap-7 md:!px-8 md:!py-7">
            <div
                class="date-tile !flex !w-20 !shrink-0 md:!w-24 !flex-col !items-center !overflow-hidden !rounded-2xl !border !border-border !bg-white !text-center !shadow-sm"
                [class.date-tile--past]="relativeDay(c.date)?.past"
                aria-hidden="true"
            >
                <span class="date-tile__month !w-full !py-1 !text-xs !font-bold !uppercase !tracking-wider">
                    {{ c.date | date : 'MMM' : '' : 'it' }}
                </span>
                <span class="!pt-1.5 !text-3xl !font-bold !leading-none !text-strong md:!text-4xl">
                    {{ c.date | date : 'd' : '' : 'it' }}
                </span>
                <span class="!pb-2 !pt-1 !text-xs !font-semibold !capitalize !text-subtle">
                    {{ c.date | date : 'EEE' : '' : 'it' }}
                </span>
            </div>

            <div class="!min-w-0 !flex-1">
                <div class="!mb-2 !flex !flex-wrap !items-center !gap-2">
                    <span
                        class="!inline-flex !items-center !rounded-full !px-2.5 !py-0.5 !text-xs !font-semibold !ring-1 !ring-inset"
                        [ngClass]="statusClass(c.status)"
                    >
                        {{ c.status }}
                    </span>
                    <span
                        *ngIf="relativeDay(c.date) as when"
                        class="!inline-flex !items-center !gap-1 !rounded-full !px-2.5 !py-0.5 !text-xs !font-semibold"
                        [ngClass]="when.past ? '!bg-zinc-100 !text-zinc-600' : '!bg-sky-50 !text-sky-800'"
                    >
                        <i class="bi bi-clock !mb-0" aria-hidden="true"></i>
                        {{ when.label }}
                    </span>
                    <span
                        *ngIf="c.categoryName"
                        class="!text-xs !font-semibold !uppercase !tracking-wider !text-subtle"
                    >
                        {{ c.categoryName }}
                    </span>
                </div>

                <h3 class="!mb-1 !text-2xl !font-bold !leading-tight !text-strong md:!text-3xl">
                    {{ c.title }}
                </h3>
                <p class="!mb-0 !text-base !font-medium !text-subtle">
                    <time [attr.datetime]="c.date">
                        {{ c.date | date : 'EEEE d MMMM y' : '' : 'it' }} · ore {{ c.date | date : 'HH:mm' : '' : 'it' }}
                    </time>
                </p>
            </div>
        </div>

        <div class="!grid !gap-5 !border-t !border-border !px-6 !py-6 md:!grid-cols-2 md:!gap-8 md:!px-8">
            <div class="!flex !gap-3">
                <span class="!flex !h-10 !w-10 !shrink-0 !items-center !justify-center !rounded-xl !bg-sky-100 !text-sky-800">
                    <i class="bi bi-geo-alt !mb-0 !text-lg" aria-hidden="true"></i>
                </span>
                <div class="!min-w-0">
                    <h4 class="!mb-1 !text-xs !font-bold !uppercase !tracking-wide !text-subtle">Luogo</h4>
                    <p class="!mb-0.5 !font-semibold !text-strong">
                        {{ c.location || 'Luogo da definire' }}
                    </p>
                    <address
                        *ngIf="c.address?.trim() || cityLine(c)"
                        class="!mb-0 !text-sm !not-italic !leading-relaxed !text-subtle"
                    >
                        <ng-container *ngIf="c.address?.trim()">{{ c.address }}</ng-container>
                        <ng-container *ngIf="c.address?.trim() && cityLine(c)">, </ng-container>
                        {{ cityLine(c) }}
                    </address>
                    <p
                        *ngIf="c.linkPosition?.trim() && !isLink(c.linkPosition)"
                        class="!mb-0 !mt-1 !text-sm !text-subtle"
                    >
                        {{ c.linkPosition }}
                    </p>
                </div>
            </div>

            <div class="!flex !gap-3" *ngIf="c.description?.trim()">
                <span class="!flex !h-10 !w-10 !shrink-0 !items-center !justify-center !rounded-xl !bg-amber-50 !text-amber-800">
                    <i class="bi bi-card-text !mb-0 !text-lg" aria-hidden="true"></i>
                </span>
                <div class="!min-w-0">
                    <h4 class="!mb-1 !text-xs !font-bold !uppercase !tracking-wide !text-subtle">Dettagli</h4>
                    <p
                        id="latest-convocation-description"
                        class="!mb-0 !whitespace-pre-line !leading-relaxed !text-strong"
                        [class.description-clamped]="isDescriptionLong(c.description) && !descriptionExpanded"
                    >
                        {{ c.description }}
                    </p>
                    <button
                        *ngIf="isDescriptionLong(c.description)"
                        type="button"
                        class="!mt-1 !p-0 !text-sm !font-semibold !text-sky-700 hover:!underline"
                        (click)="descriptionExpanded = !descriptionExpanded"
                        [attr.aria-expanded]="descriptionExpanded"
                        aria-controls="latest-convocation-description"
                    >
                        {{ descriptionExpanded ? 'Mostra meno' : 'Mostra tutto' }}
                    </button>
                </div>
            </div>
        </div>

        <footer class="!border-t !border-border !bg-zinc-50/60 !px-6 !py-4 md:!px-8 md:!py-5">
            <div class="!flex !flex-wrap !items-center !gap-3">
                <a
                    class="btn welldone-btn-light"
                    [routerLink]="['/dashboard/mister/convocations', c.id]"
                >
                    <i class="bi bi-calendar3-event me-2" aria-hidden="true"></i>
                    Scheda convocazione
                </a>
                <a
                    *ngIf="directionsUrl(c) as url"
                    [href]="url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-primary d-inline-flex align-items-center"
                >
                    <i class="bi bi-pin-map me-2" aria-hidden="true"></i>
                    Apri indicazioni
                </a>

                <button
                    *ngIf="c.invitedCount"
                    type="button"
                    id="convocated-accordion-trigger"
                    class="!ml-auto !inline-flex !items-center !gap-3 !rounded-xl !border !border-border !bg-white !py-2 !pl-2 !pr-4 !text-sm !font-semibold !text-strong hover:!border-zinc-300 hover:!bg-zinc-50"
                    (click)="toggleInvitedAccordion()"
                    [attr.aria-expanded]="invitedAccordionExpanded"
                    aria-controls="convocated-accordion-panel"
                >
                    <span *ngIf="invitedUsers.length" class="!flex !-space-x-2" aria-hidden="true">
                        <span
                            *ngFor="let user of invitedUsers.slice(0, avatarPreviewCount); trackBy: trackUserId"
                            class="avatar !flex !h-7 !w-7 !items-center !justify-center !rounded-full !text-[0.65rem] !font-bold"
                        >
                            {{ initials(user.fullName) }}
                        </span>
                    </span>
                    <i *ngIf="!invitedUsers.length" class="bi bi-people !mb-0 !pl-2 !text-subtle" aria-hidden="true"></i>
                    {{ c.invitedCount }} {{ c.invitedCount === 1 ? 'convocato' : 'convocati' }}
                    <i
                        class="bi !mb-0 !text-xs !leading-none !text-subtle"
                        [class.bi-chevron-up]="invitedAccordionExpanded"
                        [class.bi-chevron-down]="!invitedAccordionExpanded"
                        aria-hidden="true"
                    ></i>
                </button>
            </div>

            <div
                *ngIf="invitedAccordionExpanded && c.invitedCount"
                id="convocated-accordion-panel"
                class="!mt-4 !w-full !rounded-2xl !border !border-border !bg-white !p-3 !shadow-sm"
                role="region"
                aria-labelledby="convocated-accordion-trigger"
            >
                <p *ngIf="invitedLoading" class="!mb-0 !px-2 !py-1 !text-sm !text-subtle" role="status">
                    Caricamento convocati…
                </p>
                <p *ngIf="!invitedLoading && !invitedUsers.length" class="!mb-0 !px-2 !py-1 !text-sm !text-subtle">
                    Impossibile mostrare l'elenco dei convocati. Aprilo dalla scheda della convocazione.
                </p>
                <ul
                    *ngIf="!invitedLoading && invitedUsers.length"
                    class="!m-0 !grid !max-h-72 !list-none !gap-1 !overflow-y-auto !p-0 sm:!grid-cols-2"
                >
                    <li
                        *ngFor="let user of invitedUsers; trackBy: trackUserId"
                        class="!flex !items-center !gap-3 !rounded-xl !px-2 !py-2 !text-sm !text-strong"
                    >
                        <span class="avatar !flex !h-8 !w-8 !shrink-0 !items-center !justify-center !rounded-full !text-xs !font-bold" aria-hidden="true">
                            {{ initials(user.fullName) }}
                        </span>
                        <span class="!min-w-0 !flex-1 !truncate !font-medium">{{ user.fullName }}</span>
                        <span
                            *ngIf="user.roleLabel"
                            class="!shrink-0 !rounded-md !bg-zinc-100 !px-2 !py-0.5 !text-xs !font-medium !text-subtle"
                        >
                            {{ user.roleLabel }}
                        </span>
                    </li>
                </ul>
            </div>
        </footer>
    </article>
</section>
